import { computed, Injectable, signal } from '@angular/core';
import { AdminPanelUserDetails } from '../models/admin-panel-user-details';

@Injectable({
  providedIn: 'root',
})
export class AdminPanelUsersNavigationContextService {
  readonly #userDetails = signal<AdminPanelUserDetails | null>(null);
  readonly #organizationId = signal<number | null>(null);

  readonly userDetails = this.#userDetails.asReadonly();
  readonly organizationId = this.#organizationId.asReadonly();

  setUserDetailsContext(userDetails: AdminPanelUserDetails): void {
    this.#userDetails.set(userDetails);
    this.#organizationId.set(null);
  }

  setUserOrganizationDetailsContext(
    userDetails: AdminPanelUserDetails,
    organizationId: number,
  ): void {
    this.#userDetails.set(userDetails);
    this.#organizationId.set(organizationId);
  }

  clear(): void {
    this.#userDetails.set(null);
    this.#organizationId.set(null);
  }

  hasUserDetailsContext(): boolean {
    return this.#userDetails() !== null;
  }

  hasUserOrganizationDetailsContext(): boolean {
    const organizationId = this.#organizationId();

    return (
      this.#userDetails() !== null &&
      organizationId != null && Number.isInteger(organizationId) &&
      organizationId > 0
    );
  }
}
